import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Spinner from 'cd-ui-react/components/spinner';
import BusyOverlayStyles from './busy-overlay.css';

const SPINNER_POSITION_CLASSNAMES = {
	'left': BusyOverlayStyles.spinnerLeft,
	'right': BusyOverlayStyles.spinnerRight,
	'center': BusyOverlayStyles.spinnerCenter
};

const BusyOverlay = (props) => {
	let busyOverlayClassName = (props.show)
		? BusyOverlayStyles.busyOverlay
		: BusyOverlayStyles.noBusyOverlay;

	if (props.show && props.showSpinner) {
		// Spinner is to be shown as well, compute the relevant properties and class names
		busyOverlayClassName = classNames(busyOverlayClassName,
			SPINNER_POSITION_CLASSNAMES[props.spinnerPosition] || BusyOverlayStyles.spinnerCenter);

		let spinnerSize = props.spinnerSize || 'large';

		return (
			<div className={busyOverlayClassName}>
				<Spinner size={spinnerSize} />
			</div>
		);
	} else {
		// There is no spinner; either show or hide the overlay
		return (
			<div className={busyOverlayClassName} />
		);
	}
};

BusyOverlay.propTypes = {
	/**
	 * show:
	 * This *mandatory* property determines if the busy overlay must be displayed or not.
	 *     true: displayed; false: not displayed
	 */
	show: PropTypes.bool.isRequired,

	/**
	 * showSpinner:
	 * This *optional* property determines if the spinner needs to be shown.
	 * This is relevant only if the show property is true.
	 *     true: displays spinner; false: no spinner is displayed
	 */
	showSpinner: PropTypes.bool,

	/**
	 * spinnerPosition:
	 * This *optional* property determines where the spinner needs to be positioned.
	 * Valid values are 'left', 'center' and 'right'.
	 * This is relevant only if the show property is true and showSpinner is true.
	 */
	spinnerPosition: PropTypes.oneOf(['left', 'center', 'right']),

	/**
	 * spinnerSize:
	 * This *optional* property determines the size of the spinner.
	 * This is relevant only if the show property is true and showSpinner is true.
	 */
	spinnerSize: PropTypes.string
};

BusyOverlay.defaultProps = {
	/**
	 * Not display, by default
	 */
	show: false,

	/**
	 * Display spinner, by default
	 */
	showSpinner: true,

	/**
	 * Display spinner in the center, by default.
	 */
	spinnerPosition: 'center',

	/**
	 * Display large sized spinner, by default.
	 */
	spinnerSize: 'large'
};

export default BusyOverlay;
